import { render, staticRenderFns } from "./tableBranchLocation.vue?vue&type=template&id=18282a2a&"
import script from "./tableBranchLocation.vue?vue&type=script&lang=js&"
export * from "./tableBranchLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports